// SMPTE timecodes from H.264 pic_timing SEI (payload type 1, needs the SPS) and H.265 time_code SEI
// (payload type 136) in MPEG-TS fragments. hls.js doesn't report these, so the raw fragment data is parsed
// (from the fragment loader). Only the NAL units before the first slice of each PES are looked at.

const PACKET = 188;
const MAX_SAMPLES = 3000;
const H264_PROFILES_WITH_CHROMA = [100, 110, 122, 244, 44, 83, 86, 118, 128, 138, 139, 134, 135];
// H.264 NumClockTS by pic_struct
const CLOCK_TS = [1, 1, 1, 2, 2, 3, 3, 2, 3];

function packet_pid(u8, o) {
	return ((u8[o + 1] & 0x1f) << 8) | u8[o + 2];
}

function payload_start(u8, o) {
	return u8[o + 3] & 0x20 ? o + 5 + u8[o + 4] : o + 4;
}

// {pid, codec: "h264" | "hevc"} of the first video stream in the PMT
function video_stream(u8) {
	var pmt = -1;
	for (var o = 0; o + PACKET <= u8.length; o += PACKET) {
		if (u8[o] !== 0x47 || !(u8[o + 1] & 0x40)) continue;
		var pid = packet_pid(u8, o);
		var p = payload_start(u8, o);
		p += u8[p] + 1;
		if (pid === 0 && pmt < 0) {
			pmt = packet_pid(u8, p + 9);
		} else if (pid === pmt) {
			var end = p + 3 + (((u8[p + 1] & 0x0f) << 8) | u8[p + 2]) - 4;
			var q = p + 12 + (((u8[p + 10] & 0x0f) << 8) | u8[p + 11]);
			while (q + 5 <= end) {
				if (u8[q] === 0x1b) return {pid: packet_pid(u8, q), codec: "h264"};
				if (u8[q] === 0x24) return {pid: packet_pid(u8, q), codec: "hevc"};
				q += 5 + (((u8[q + 3] & 0x0f) << 8) | u8[q + 4]);
			}
			return null;
		}
	}
	return null;
}

// RBSP without emulation prevention bytes
function unescape_rbsp(data, start, end) {
	var out = new Uint8Array(end - start);
	var n = 0;
	var zeros = 0;
	for (var i = start; i < end; i++) {
		var b = data[i];
		if (zeros >= 2 && b === 3) {
			zeros = 0;
			continue;
		}
		out[n++] = b;
		zeros = b === 0 ? zeros + 1 : 0;
	}
	return out.subarray(0, n);
}

class BitReader {
	constructor (data) {
		this.data = data;
		this.pos = 0;
	}
	bits (n) {
		var v = 0;
		for (var i = 0; i < n; i++) {
			var byte = this.data[this.pos >> 3];
			if (byte === undefined) throw new Error("end of data");
			v = v * 2 + ((byte >> (7 - (this.pos & 7))) & 1);
			this.pos++;
		}
		return v;
	}
	flag () {
		return this.bits(1) === 1;
	}
	ue () {
		var zeros = 0;
		while (this.bits(1) === 0) {
			if (++zeros > 31) throw new Error("bad exp-golomb");
		}
		return zeros ? Math.pow(2, zeros) - 1 + this.bits(zeros) : 0;
	}
	se () {
		var v = this.ue();
		return v & 1 ? (v + 1) / 2 : -v / 2;
	}
}

function skip_scaling_list(r, size) {
	var last = 8;
	var next = 8;
	for (var j = 0; j < size; j++) {
		if (next !== 0) next = (last + r.se() + 256) % 256;
		last = next === 0 ? last : next;
	}
}

function parse_hrd(r) {
	var cpb_cnt = r.ue() + 1;
	r.bits(8);
	for (var i = 0; i < cpb_cnt; i++) {
		r.ue();
		r.ue();
		r.bits(1);
	}
	r.bits(5);
	return {
		cpb_removal_delay_length: r.bits(5) + 1,
		dpb_output_delay_length: r.bits(5) + 1,
		time_offset_length: r.bits(5)
	};
}

// The fields pic_timing needs; null when the SPS has no VUI
function parse_h264_sps(rbsp) {
	var r = new BitReader(rbsp);
	r.bits(8); // NAL header
	var profile = r.bits(8);
	r.bits(16);
	r.ue();
	if (H264_PROFILES_WITH_CHROMA.includes(profile)) {
		var chroma = r.ue();
		if (chroma === 3) r.bits(1);
		r.ue();
		r.ue();
		r.bits(1);
		if (r.flag()) {
			for (var i = 0; i < (chroma === 3 ? 12 : 8); i++) {
				if (r.flag()) skip_scaling_list(r, i < 6 ? 16 : 64);
			}
		}
	}
	r.ue();
	var poc_type = r.ue();
	if (poc_type === 0) {
		r.ue();
	} else if (poc_type === 1) {
		r.bits(1);
		r.se();
		r.se();
		var n = r.ue();
		for (var k = 0; k < n; k++) r.se();
	}
	r.ue();
	r.bits(1);
	r.ue();
	r.ue();
	if (!r.flag()) r.bits(1);
	r.bits(1);
	if (r.flag()) {
		r.ue();
		r.ue();
		r.ue();
		r.ue();
	}
	if (!r.flag()) return null;
	if (r.flag() && r.bits(8) === 255) r.bits(32);
	if (r.flag()) r.bits(1);
	if (r.flag()) {
		r.bits(5);
		if (r.flag()) r.bits(24);
	}
	if (r.flag()) {
		r.ue();
		r.ue();
	}
	if (r.flag()) r.bits(65);
	var nal_hrd = r.flag() ? parse_hrd(r) : null;
	var vcl_hrd = r.flag() ? parse_hrd(r) : null;
	var hrd = nal_hrd || vcl_hrd;
	if (hrd) r.bits(1);
	return {
		hrd: hrd,
		pic_struct_present: r.flag()
	};
}

// One clock timestamp; fields missing from a partial timestamp come from the previous one
function read_clock_ts(r, h264, time_offset_length, prev) {
	if (h264) r.bits(2);
	r.bits(1);
	r.bits(5);
	var full = r.flag();
	r.bits(1);
	var dropped = r.flag();
	var frames = r.bits(h264 ? 8 : 9);
	var tc = {hours: prev ? prev.hours : 0, minutes: prev ? prev.minutes : 0, seconds: prev ? prev.seconds : 0, frames: frames, drop: dropped};
	if (full) {
		tc.seconds = r.bits(6);
		tc.minutes = r.bits(6);
		tc.hours = r.bits(5);
	} else if (r.flag()) {
		tc.seconds = r.bits(6);
		if (r.flag()) {
			tc.minutes = r.bits(6);
			if (r.flag()) tc.hours = r.bits(5);
		}
	}
	if (time_offset_length > 0) r.bits(time_offset_length);
	return tc;
}

function parse_h264_pic_timing(payload, sps, prev) {
	if (!sps || !sps.pic_struct_present) return null;
	var r = new BitReader(payload);
	if (sps.hrd) r.bits(sps.hrd.cpb_removal_delay_length + sps.hrd.dpb_output_delay_length);
	var pic_struct = r.bits(4);
	var count = CLOCK_TS[pic_struct] || 0;
	var tc = null;
	for (var i = 0; i < count; i++) {
		// Only the first clock timestamp of the picture is shown
		if (r.flag() && !tc) tc = read_clock_ts(r, true, sps.hrd ? sps.hrd.time_offset_length : 24, prev);
		else if (tc) break;
	}
	return tc;
}

function parse_hevc_time_code(payload, prev) {
	var r = new BitReader(payload);
	var count = r.bits(2);
	for (var i = 0; i < count; i++) {
		if (!r.flag()) continue;
		var tc = read_clock_ts(r, false, 0, prev);
		return tc;
	}
	return null;
}

function sei_messages(rbsp, header_len, on_message) {
	var i = header_len;
	while (i < rbsp.length && !(rbsp[i] === 0x80 && i === rbsp.length - 1)) {
		var type = 0;
		while (rbsp[i] === 0xff) {
			type += 255;
			i++;
		}
		type += rbsp[i++];
		var size = 0;
		while (rbsp[i] === 0xff) {
			size += 255;
			i++;
		}
		size += rbsp[i++];
		if (i + size > rbsp.length || isNaN(type) || isNaN(size)) return;
		on_message(type, rbsp.subarray(i, i + size));
		i += size;
	}
}

export function formatTimecode(tc) {
	var p = (v) => (v < 10 ? "0" : "") + v;
	return p(tc.hours) + ":" + p(tc.minutes) + ":" + p(tc.seconds) + (tc.drop ? ";" : ":") + p(tc.frames);
}

export class SeiTimecodes {
	constructor () {
		this.sps = null;
		this.prev = null;
		this.pes = [];
		this.pes_cc = 0;
		// [{t: PTS in seconds, cc, tc}]
		this.samples = [];
	}
	// Raw TS data of a fragment; must be called before hls.js gets (and detaches) the buffer
	push (buffer, cc) {
		var u8 = new Uint8Array(buffer);
		var video = video_stream(u8);
		if (!video) return;
		this.codec = video.codec;
		for (var o = 0; o + PACKET <= u8.length; o += PACKET) {
			if (u8[o] !== 0x47 || packet_pid(u8, o) !== video.pid || !(u8[o + 3] & 0x10)) continue;
			var start = payload_start(u8, o);
			if (start >= o + PACKET) continue;
			if (u8[o + 1] & 0x40) this.flush();
			if (!(u8[o + 1] & 0x40) && !this.pes.length) continue;
			this.pes.push(u8.subarray(start, o + PACKET));
			this.pes_cc = cc;
		}
		this.flush();
	}
	flush () {
		if (!this.pes.length) return;
		var parts = this.pes;
		this.pes = [];
		var len = parts.reduce((s, p) => s + p.length, 0);
		var data = new Uint8Array(len);
		var o = 0;
		parts.forEach((p) => { data.set(p, o); o += p.length; });
		if (len < 9 || data[0] !== 0 || data[1] !== 0 || data[2] !== 1 || !(data[7] & 0x80)) return;
		var p = 9;
		var pts = ((data[p] & 0x0e) * 536870912 + (data[p + 1] << 22) + ((data[p + 2] & 0xfe) << 14) + (data[p + 3] << 7) + ((data[p + 4] & 0xfe) >> 1)) / 90000;
		var tc = this.parse_access_unit(data, 9 + data[8]);
		if (!tc) return;
		this.prev = tc;
		this.samples.push({t: pts, cc: this.pes_cc, tc: tc});
		if (this.samples.length > MAX_SAMPLES + 500) this.samples.splice(0, this.samples.length - MAX_SAMPLES);
	}
	// NAL units up to the first slice
	parse_access_unit (data, start) {
		var hevc = this.codec === "hevc";
		var found = null;
		var nal_start = -1;
		var handle = (s, e) => {
			// Trailing zeros belong to the next start code
			while (e > s && data[e - 1] === 0) e--;
			if (e <= s) return false;
			var type = hevc ? (data[s] >> 1) & 0x3f : data[s] & 0x1f;
			var vcl = hevc ? type < 32 : type >= 1 && type <= 5;
			if (vcl) return true;
			try {
				if (!hevc && type === 7) {
					this.sps = parse_h264_sps(unescape_rbsp(data, s, e)) || this.sps;
				} else if ((!hevc && type === 6) || (hevc && (type === 39 || type === 40))) {
					sei_messages(unescape_rbsp(data, s, e), hevc ? 2 : 1, (pt, payload) => {
						if (found) return;
						if (!hevc && pt === 1) found = parse_h264_pic_timing(payload, this.sps, this.prev);
						else if (hevc && pt === 136) found = parse_hevc_time_code(payload, this.prev);
					});
				}
			} catch (err) {
				// Broken or unsupported NAL unit
			}
			return false;
		};
		for (var i = start; i + 2 < data.length; i++) {
			if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 1) {
				if (nal_start >= 0 && handle(nal_start, i)) return found;
				nal_start = i + 3;
				i += 2;
			}
		}
		if (nal_start >= 0) handle(nal_start, data.length);
		return found;
	}
	// Timecode of the frame at media time t; offsets: {cc: initPTS in seconds}
	timecode (t, offsets) {
		var s = this.samples;
		for (var i = s.length - 1; i >= 0; i--) {
			var offset = offsets[s[i].cc];
			if (offset === undefined) continue;
			var mt = s[i].t - offset;
			if (mt <= t + 0.001) return t - mt <= 2 ? s[i].tc : null;
		}
		return null;
	}
	reset () {
		this.sps = null;
		this.prev = null;
		this.pes = [];
		this.samples = [];
	}
}
